import AutocompleteWrapper from '@/components/AutocompleteWrapper/AutocompleteWrapper'
import type { TypeAheadConfigEndpoint } from '@/components/TypeAhead/types'
import type { GA4PageNameType } from '@/ga4types'
import useBootstrapData from '@/hooks/useBootstrapData'
import useSeti from '@/hooks/useSeti'
import logSearchFormAnalytics from '@/shared-utils/log-search-form-analytics'
import type { LOCATION_SEARCH_TYPE } from '@/types'
import { CarSearchForm } from '@pcln/horizon-search-form'
import { handleSubmitForCars } from '../SearchForm/utils'
import { fireBundleAndSaveEvent, fireItemClickEvent } from '../ga4'
import type { CAR_FORM_STATE_TYPE } from '../types'
import useCarFormInitialValues from './useCarFormInitialValues'

type FormType = {
  onSubmit?: (data: CAR_FORM_STATE_TYPE, pageName: GA4PageNameType) => void
  setLocation?: (city?: LOCATION_SEARCH_TYPE) => void
  pageName?: 'homepage' | 'landing'
}

export default function HorizonCarForm({
  onSubmit = handleSubmitForCars,
  setLocation,
  pageName = 'homepage',
}: Readonly<FormType>) {
  const { locale: { localeCode = 'en-US' } = {} } = useBootstrapData()
  const { initialValues, isMobile, cguid } = useCarFormInitialValues()
  const removeBackground =
    useSeti({ experimentCode: 'HP_SEARCH_FORM_HORIZON_CROSS_SELL_DESKTOP' }) === 'VARIANT'

  return (
    <CarSearchForm
      initialValues={initialValues}
      isMobile={isMobile}
      autoAdvance={!isMobile}
      localeCode={localeCode}
      setLocation={setLocation}
      removeBackground={removeBackground}
      onItemClick={() => fireItemClickEvent()}
      onBundleChange={(tripType, checked) => {
        if (checked) {
          try {
            fireBundleAndSaveEvent(tripType)
          } catch {
            // GA4TripTypeMapper may throw on unexpected trip type combinations
          }
        }
      }}
      onSubmit={(data) => {
        onSubmit(data, pageName)
        logSearchFormAnalytics({ cguid, pageName, productType: 'cars', isMobile })
      }}
      renderAutocomplete={(props) => (
        <AutocompleteWrapper
          ref={props.inputRef}
          searchKey={props.searchKey}
          label={props.label}
          typeAheadEndpoint={props.typeAheadEndpoint as TypeAheadConfigEndpoint}
          errorMessage={props.errorMessage}
          initialSelectedItem={props.initialSelectedItem}
          onItemSelect={(item) => props.onItemSelect(item)}
        />
      )}
    />
  )
}
